import OrderDetailContainer from "./OrderDetailContainer"

// /procurement/my-orders/:id — same GET /order-requests/{id} detail as the
// Order Request page; this route just arrives from the "My Orders" list.
// The previous version of this page rendered a purchase → goods-receipt →
// payment lifecycle timeline, but no API returns that P2P tracking data (only
// the plain order_request status), so it's been dropped in favor of the same
// real detail view used everywhere else rather than fabricating stage data.
const MyOrderDetailContainer = () => (
  <OrderDetailContainer backTo="/procurement/my-orders" backLabel="My Orders" />
)

export default MyOrderDetailContainer
